module.exports = __webpack_public_path__ + "img/14_newYouth_lxm.5cdb0565.png";